import Link from 'next/link'
import { HiChevronRight } from 'react-icons/hi'
import Image from './Image'
import { ResultTag, ResultTags } from './ResultTag'
import VerifiedBadge from './VerifiedBadge'
import { getAvatarURL, isAvatarVerified } from 'helpers/avatar'
import getTags from 'helpers/getTags'
import type { NfdRecord } from 'api/api-client'

interface ListResultProps {
  nfd: NfdRecord
  walletAddress: string
}

export default function ListResult({ nfd, walletAddress }: ListResultProps) {
  const isForSale = nfd.state === 'forSale'
  const isReservedForUser = nfd.reservedFor === walletAddress

  const renderVerifiedBadge = () => {
    const isVerified = isAvatarVerified(nfd)

    if (isVerified) {
      return (
        <>
          <div className="absolute bottom-0 right-0 -mr-1 -mb-1">
            <VerifiedBadge circle />
          </div>
        </>
      )
    }

    return null
  }

  return (
    <li key={nfd.name}>
      <Link href={`/name/${nfd.name}`} passHref>
        <a className="group block">
          <div className="flex items-center px-4 py-4 sm:px-6">
            <div className="min-w-0 flex-1 flex items-center">
              <div className="flex-shrink-0 relative h-12 w-12 rounded-full bg-gray-200">
                <div className="rounded-full bg-gray-200 overflow-hidden">
                  <Image
                    className="object-cover rounded-full group-hover:opacity-75"
                    src={getAvatarURL(nfd)}
                    alt=""
                    layout="fill"
                    objectFit="cover"
                    fallbackSrc="/img/nfd-loading-placeholder_error.jpg"
                    loadingSrc="/img/nfd-loading-placeholder.jpg"
                  />
                </div>
                {renderVerifiedBadge()}
              </div>
              <div className="min-w-0 flex-1 px-4 xl:grid xl:grid-cols-2 xl:gap-4">
                <div className="flex items-center">
                  <p className="text-sm sm:text-base md:text-lg font-medium truncate">
                    <span className="mr-3">{nfd.name}</span>
                    <wbr />
                    {isReservedForUser ? (
                      <ResultTag label="Claim Now" brand />
                    ) : isForSale ? (
                      <ResultTag label="For Sale" brand />
                    ) : null}
                  </p>
                </div>
                <div className="hidden xl:flex items-center">
                  <ResultTags tags={getTags(nfd, { premium: true })} />
                </div>
              </div>
            </div>
            <div>
              <HiChevronRight
                className="h-5 w-5 text-gray-400 group-hover:text-gray-700"
                aria-hidden="true"
              />
            </div>
          </div>
        </a>
      </Link>
    </li>
  )
}
